<template>
<div class="users-out">
    <CDNTabs :tabs="tabs" />
    <div class="users-manage">
      <div class="menu-title">

    <CDNbreadcrumbs :items="items" />

        <div class="menu-right" v-if="!staticShow && !settingShow">
          <!--  -->
         <div class="filter-container" @click="filterClick">
                <CDNButton
                  :BtnText="$t('common.filter')"
                  :hasBg="isFilter"
                  :imgPath="require('@/assets/images/products/icon_filter.png')"
                />
                <CDNButton
                  :hasBg="isFilter"
                  :imgPath="require('@/assets/images/products/icon_down.png')"
                  innerstyle="margin-left: 5px;"
                />
              </div>
          <CDNButton
            :BtnText="$t('common.refresh')"
            :imgPath="require('@/assets/images/products/icon_refresh.png')"
            innerstyle="margin-left: 12px;"
            @btnclick="refresh"
          />

          <CDNButton
            :BtnText="$t('allDomain.addsubdomain')"
            :imgPath="require('@/assets/images/domain/icon_domain.png')"
            innerstyle="margin-left: 12px;"
            @btnclick="showAddSubdomainDiag = true"
          />

          <CDNButton
            :BtnText="$t('allDomain.originSite')"
            :imgPath="require('@/assets/images/domain/origin_address.png')"
            innerstyle="margin-left: 12px;"
            @btnclick="clickUpstreamSets"
          />

          <CDNButton
            :BtnText="$t('product.delete')"
            :imgPath="require('@/assets/images/domain/icon_delete.png')"
            innerstyle="margin-left: 12px;"
            @btnclick="commitDels"
          />
        </div>
      </div>
      <div class="input-container" v-show="isFilter && !staticShow && !settingShow">
        <loginInput
          :label="$t('allDomain.domain')"
          :appendIcon="require('@/assets/images/products/prod_icon_user.png')"
          inputStyle="width: 288px;"
          realInputStyle="width: 288px;"
          @changeInput="(e) => (searchDomain = e)"
          :inputValue="searchDomain"
        />
        <CDNDatePicker
          ref="createdate"
          :label="$t('allDomain.createDate')"
          innerStyle="width: 288px; margin-left: 24px;"
          @changeDate="(date) => (createDate = date)"
          type="daterange"
        />
      </div>

      <div class="search-btn-content" v-show="isFilter && !staticShow && !settingShow">
        <CDNButton
          :hasBg="true"
          :imgPath="require('@/assets/images/products/prod_icon_search.png')"
          innerstyle="padding: 6px 20px;"
          :BtnText="$t('common.search')"
          @btnclick="searchClick"
        />
        <CDNButton
          :imgPath="require('@/assets/images/products/prod_icon_reset.png')"
          innerstyle="margin-left: 20px;padding: 6px 20px;"
          :BtnText="$t('common.reset')"
          @btnclick="resetClick"
        />
      </div>

      <!-- 列表 -->
      <el-table
        v-if="!staticShow && !settingShow"
       :data="tableData"
       style="width: 100%"
    @selection-change="selectedRows">
      <el-table-column
        align="center"
        width="55"
        type="selection"
      >
      </el-table-column>
        <el-table-column
          align="center"
          prop="host"
          :label="$t('product.childDomain')"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="hyDZ"
          :label="$t('allDomain.originAddress')"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="scheme"
          :label="$t('allDomain.InternetProtocol')"
        >
        </el-table-column>
        
        <el-table-column
          align="center"
          prop="host"
          :label="$t('product.handle')"
        >
        <template slot-scope="scope">
           <div>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('allDomain.config')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  :type="'success'"
                  icon="el-icon-s-tools"
                  @click="$router.push({name: 'subdomain_settings', params: { id: id, sid: scope.row.id }})"
                  circle
                ></el-button>
              </el-tooltip>

              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('product.Statistics')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="warning"
                  icon="el-icon-s-data"
                  @click="$router.push({name: 'subdomain_static', params: { id: id, sid: scope.row.id }})"
                  circle
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content=" $t('product.delete')"
                placement="top-start"
              >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="deleteClick(scope.row)"
                  circle
                ></el-button>
              </el-tooltip>
            </div>
        </template>
        </el-table-column>
      </el-table>
     
      <div class="pagination-bottom" v-if="!staticShow && !settingShow">
        <Pagination
          :total="total"
          :page-size="pageSize"
          :page-count="pageCount"
          @change="handleChange"
        />
      </div>
      <!-- 列表 -->
    </div>
    <!-- 密码验证 -->

    <!-- 删除 -->
    <el-dialog
      :title="$t('allDomain.passwordAuth')"
      :visible.sync="showpasswordDiag"
      width="532px"
    >
    <div class="dialog-content">
      <loginInput
         inputStyle="margin-bottom: 10px;"
         realInputStyle="height: 40px;"
         @changeInput="e => certPassword = e"
         type="password"
          />
        <div class="btn-content">
          <div @click="commitDelete">{{$t('allDomain.confirm')}}</div>
          <div @click="showpasswordDiag = false">{{$t('allDomain.cancel')}}</div>
        </div>
    </div>
    </el-dialog>
    <!-- 防御 -->
    
    <el-dialog
      :title="$t('product.defense')"
      :visible.sync="showdefenseDiag"
      width="532px"
    >
      <div class="dialog-content">
        <div class="lan-dong">
      <CDNSwitch
        :label="$t('allDomain.tip111')"
        :hasbottomline="false"
        @change="jsDefenseChange"
      />
      <CDNSwitch
        :label="$t('allDomain.tip112')"
        :hasbottomline="false"
        @change="checkCodeChange"
      />
        </div>
        <div class="btn-content">
          <div @click="commitOrigin">{{$t('allDomain.confirm')}}</div>
          <div @click="showOriginDiag = false">{{$t('allDomain.cancel')}}</div>
        </div>
      </div>
    </el-dialog>
<!--  -->
    <el-dialog
      :title="$t('allDomain.originOper')"
      :visible.sync="showOriginDiag"
      width="532px"
    >
  <el-tabs v-model="tabs_activename">
    <el-tab-pane :label="$t('allDomain.originSettings')" name="settings">

      <div class="dialog-content">
        <div class="lan-dong">
          <span class="text-gray-style">
            *{{ $t('allDomain.originSite') }}</span>
          <div style="margin-top: 8px">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="11.22.33.44:80s"
              v-model="upstreamSetVal"
            >
            </el-input>
            <div>{{$t('allDomain.upstreamTip')}}</div>
          </div>
        </div>
        <!--  -->
        <div class="btn-content">
          <div @click="commitUpstreamSets">{{$t('allDomain.confirm')}}</div>
          <div @click="showOriginDiag = false">{{$t('allDomain.cancel')}}</div>
        </div>
      </div>

    </el-tab-pane>
    <el-tab-pane :label="$t('allDomain.originReplace')" name="replace">
      <div class="dialog-content">
        <div class="lan-dong">
          <span class="text-gray-style">* {{$t('allDomain.tip3')}}</span>
          <div style="margin-top: 8px">
            <el-input
              type="text"
              v-model="sourceIP"
            >
            </el-input>
          </div>
        </div>
        <div class="lan-dong">
          <span class="text-gray-style">* {{$t('allDomain.tip4')}}</span>
          <div style="margin-top: 8px">
            <el-input
              type="text"
              v-model="targetIP"
            >
            </el-input>
          </div>
        </div>
        <!--  -->
        <div class="btn-content">
          <div @click="commitUpstreamReplaces">{{$t('allDomain.confirm')}}</div>
          <div @click="showOriginDiag = false">{{$t('allDomain.cancel')}}</div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
      
    </el-dialog>
    <!--  -->
    <el-dialog
      :title="$t('allDomain.addsubdomain')"
      :visible.sync="showAddSubdomainDiag"
      width="532px"
    >
      <div class="dialog-content">
        <div class="lan-dong">
          <span class="text-gray-style">*{{$t('allDomain.mainDomain')}}</span>

          <div style="margin-top: 24px">
            <el-input
              type="text"
              disabled
              placeholder=""
              v-model="subhostsTextarea"
            >
            </el-input>
          </div>
        </div>
        <div class="lan-dong">
          <span class="text-gray-style">
            *{{`${$t('product.childDomain')} ${$t('allDomain.originSite')}`}}</span>
          <div style="margin-top: 24px">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="aaa 11.22.33.44:80s"
              v-model="upstreamTextarea"
            >
            </el-input>
            <div>{{$t('allDomain.upstreamTip')}}</div>
          </div>
        </div>
        <!--  -->
        <div class="btn-content">
          <div @click="commitOrigin">{{$t('allDomain.confirm')}}</div>
          <div @click="showAddSubdomainDiag = false">{{$t('allDomain.cancel')}}</div>
        </div>
      </div>
    </el-dialog>

        <domainConfig
          v-if="settingShow && !staticShow"
          @closePage="settingShow=false"
          :domainHost="domainHost"
          :childDomainId="childDomainId"
        />
     <staticData
          v-if="staticShow && !settingShow"
          :current_host="current_host"
          @closePage="staticShow=false"
        />
  </div>
</template>

<script>
/* eslint-disable */
import { childDomainList, addNewChildDomain, delChildDomain,
  apiGetDetail, apiHostBatchEdit } from '@/service/requestRes';
import staticData from '@/views/domain/staticData.vue';
import domainConfig from '@/views/dev/domainConfig.vue';
import { upstream_str2list_domain, upstream_str2list }from '@/utils/upstreams';

export default {
  components: {
    staticData,
    domainConfig,
  },
  data() {
    return {
      id: this.$route.params.id,      
      searchDomain: "",
      createDate: "",
      tableData: [],
      showAddSubdomainDiag: false,
      showOriginDiag: false,
      showdefenseDiag: false,
      subhostsTextarea: "",
      upstreamTextarea: '',
      upstreamSetVal:'',
      sourceIP:'',
      targetIP:'',
      certPassword: '',
      total: 0,
      pageSize: 10,
      pageCount: 1,
      selectItems: [],
      isFilter: false,
      sub_host: '',
      staticShow: false,
      settingShow: false,
      showpasswordDiag: false,
      current_host: '',
      domainHost: '',
      childDomainId: 0,
      tabs_activename: 'settings',
    };
  },
  // created() {
  //   this.sub_host = this.$route.query.sub_host;
  //   this.subhostsTextarea = this.sub_host;
  // },
  mounted() {
    this.getDetail();
    // this.getchildDomainList({page: 1});
  },
  computed: {
    headerLables() {
      return [
        { label: this.$t("product.childDomain"), value: "host" },
        { label: this.$t("allDomain.originAddress"), value: "hyDZ" },
        { label: this.$t("allDomain.InternetProtocol"), value: "scheme" },
        { label: this.$t("product.handle"), value: "handle" },
      ];
    },
    tabs() {
      return [this.$t("allDomain.DomainNames")];
    },
    items() {
      return [
        {
          label: this.$t('allDomain.DomainNames'),
          click: () => {
            this.$router.back();
          },
        },
        {
          label: this.$t('allDomain.childDomain') + " | " + this.sub_host,
        },
      ];
    },
  },
  methods: {
    getDetail() {
      apiGetDetail(
          'subhost', this.id
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.sub_host = data.sub_host;
            this.subhostsTextarea = this.sub_host;
            this.getchildDomainList({page: 1});
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    jsDefenseChange(e) {},
    checkCodeChange(e) {},
    commitDelete() {
      if (!this.certPassword) {
          this.$message({
            message: this.$t('allDomain.tip5'),
            type: "error",
          });
        return;
      }
      this.delDomain({ host: this.current_host, password: this.certPassword });

     this.showpasswordDiag = false;
    },
    deleteClick(item) {
      console.log("&&", item);
      this.current_host = item.host;
      this.showpasswordDiag = true;
    },
    delDomain({ host, password }) {
      delChildDomain({ host, password }).then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: host + ": "+ this.$t('common.success'),
            type: "success",
          });
          this.getchildDomainList({page: 1});
        } else {
          this.$message({
            message: host + ": " + msg,
            type: "error",
          });
        }
      });
    },
    getchildDomainList({ page, start_date, end_date, pid, states, host }) {
      console.debug(this.sub_host);
      childDomainList({
        page,
        limit: this.pageSize,
        start_date,
        end_date,
        sub_host: this.sub_host,
        pid,
        states,
        host,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { list } = data || {};
          const { total } = list || {};
          this.total = total;
          this.tableData =
            list.data &&
            list.data.map((item) => {
              const host_json_server = item.host_json_server;
              const hostJson = JSON.parse(host_json_server);
              const upstreams = hostJson.upstreams;
              let myarray = upstreams && upstreams.map( upItem => {
                  let myitem = [];
                  myitem.push(upItem.addr)
                  myitem.push(
                    [upItem.port?upItem.port:'',upItem.isSSL?'s':''].join(''))
                  return myitem.filter(x=>x).join(':')
              });
              return {
                ...item,
                hyDZ: myarray.join('/'),
                scheme: hostJson.scheme
              };
            });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    addNewDomain({ subhosts, upstreams }) {
      addNewChildDomain({ subhosts, upstreams }).then(res => {
        const { code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });          
          this.getchildDomainList({ page: 1 });
          this.showAddSubdomainDiag = false;
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    handleChange(e) {
      console.log("pagination", e);
      this.getmainDomainList({ page: e });
    },
    commitOrigin() {
      if (!this.subhostsTextarea) {
         this.$message({
            message: this.$t('allDomain.tip6'),
            type: "error",
          });
        return;
      }

      if (!this.upstreamTextarea) {
         this.$message({
            message: this.$t('allDomain.tip7'),
            type: "error",
          });
        return;
      }

      const subhostsArr = this.subhostsTextarea.split('\n');
      const newData = upstream_str2list_domain(this.upstreamTextarea);
      this.addNewDomain({subhosts: subhostsArr, upstreams: newData});
    },
    clickUpstreamSets(){
      if (this.selectItems.length == 0) {
          this.$message({
            message: this.$t('allDomain.tip8'),
            type: "error",
          });
          return;
      } 
      this.showOriginDiag = true;     
    },
    commitUpstreamSets(){
      if (!this.upstreamSetVal){
          this.$message({
            message: this.$t('allDomain.tip9'),
            type: "error",
          });
          return;
      }
      let para = {
        func: 'upstreams_sets',
        hosts: this.selectItems.map(item => item.host),
        upstreams: upstream_str2list(this.upstreamSetVal),
      }
      apiHostBatchEdit(para).then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
          this.upstreamSetVal = '';
          this.showOriginDiag = false;          
          this.getchildDomainList({page: 1});
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    commitUpstreamReplaces(){
      if (!this.sourceIP || !this.targetIP){
          this.$message({
            message: this.$t('allDomain.tip9'),
            type: "error",
          });
          return;
      }

      // const arr = this.targetIP.split(':');
      // if (arr[1]) {
      //     this.$message({
      //       message: this.$t('allDomain.tip10'),
      //       type: "error",
      //     });
      //   return;
      // }

      let para = {
        func: 'upstreams_replaces',
        hosts: this.selectItems.map(item => item.host),
        sourceIP: this.sourceIP,
        targetIP: this.targetIP,
      }
      apiHostBatchEdit(para).then(res => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
          this.sourceIP = '';
          this.targetIP = '';
          this.showOriginDiag = false;          
          this.getchildDomainList({page: 1});
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    commitDels(){
      if (this.selectItems.length == 0) {
          this.$message({
            message: this.$t('allDomain.tip8'),
            type: "error",
          });
          return;
      }      
      this.$prompt(
        this.$t('allDomain.delete') + this.selectItems.map(item => item.host), 
        this.$t('Login.placeholdPwd'),
        { confirmButtonText: this.$t('allDomain.confirm'),
        cancelButtonText: this.$t('allDomain.cancel'),
        inputPattern: /^.{1,}$/,
        inputErrorMessage: this.$t('Login.placeholdPwd')
      }).then(({ value }) => {
        this.selectItems.forEach(item => {
          this.delDomain({ host: item.host, password:value });
        });
        this.showpasswordDiag = false;
        this.refresh();

      }).catch((e) => {
        console.error(e);
        this.$message({
          type: 'info',
          message: 'cancel'
        });       
      });
    },
    selectedRows(items) {
      this.selectItems = items;
    },
    refresh() {
      this.getchildDomainList({ page: 1 });
    },
    filterClick() {
      this.isFilter = !this.isFilter;
    },
    configClick(item) {
      this.domainHost = item.host;
      this.childDomainId = item.id;
      this.settingShow = true;
    },
    editClick(item) {
      console.log(item);
    },
    searchClick() {
      console.log("--", this.searchDomain, this.createDate);
      let start = "";
      let end = "";
      if (this.createDate && this.createDate.length) {
        start = this.createDate[0];
        end = this.createDate[1];
      }
      this.getchildDomainList({
        page: 1,
        start_date: start,
        end_date: end,
        sub_host: this.sub_host,
        host: this.searchDomain
      });
    },
    resetClick() {
      this.searchDomain = "";
      this.$refs.createdate.changeDate('');
    },
    childDomainClick(item) {
      console.log(item);
      this.showdefenseDiag = true;
    },
    tongjiClick(item) {
      this.staticShow = true;
      this.current_host = item.host;
    },
  },
};
</script>

<style lang="scss" scoped>
.users-out {
  width: 1276px;
  margin: 24px auto;
}
.users-manage {
  background-color: white;
  padding: 24px;
  border-radius: 4px;
  .menu-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5a607f;
    }
    .menu-right {
      height: 60px;
      display: flex;
      align-items: center;
    }
  }
  .filter-container {
    display: flex;
    align-items: center;
  }
  .input-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  .search-btn-content {
    display: flex;
    margin-bottom: 49px;
  }
  .user-handle {
    display: flex;
    align-items: center;
    :first-child {
      margin-right: 10px;
      width: 16px;
      height: 16px;
    }
    :last-child {
      width: 18px;
      height: 19px;
    }
  }

  .handle-first {
    display: flex;
    align-items: center;
    :nth-child(1) {
      margin-right: 10px;
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      cursor: pointer;
    }
    :nth-child(2) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      margin-right: 10px;
      cursor: pointer;
    }

    :nth-child(3) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      margin-right: 10px;
      color: #003600;
      cursor: pointer;
    }

    :nth-child(4) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      cursor: pointer;
    }

    :nth-child(5) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      cursor: pointer;
    }
  }
}

.dialog-content {
    margin-top: -20px;
    .lan-dong {
      margin-top: 28px;
    }
    .btn-content {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 15px;
      :first-child {
        padding: 8px 20px;
        background: #336dff;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        margin-right: 10px;
      }
      :last-child {
        padding: 8px 20px;
        background: #336dff;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        margin-right: 6px;
      }
    }
    .diag-tip {
      margin: 12px 0;
      font-size: 14px;
      color: #666666;
    }
  }
</style>
